<template>
  <v-btn
      :outlined="true"
      :loading="loading"
      :disabled="loading"
      color="success"
      @click="init"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <v-icon>
      mdi-plus
    </v-icon>

    <slot/>

    <v-dialog
        v-model="dialog"
        :persistent="true"
        :scrollable="true"
        max-width="500"
    >
      <v-card>
        <v-card-title>
          Vytvoriť číselník

          <v-spacer/>

          <v-btn
              :icon="true"
              color="default"
              @click="closeDialog"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
              @submit.stop.prevent="submit"
          >
            <v-row>
              <v-col
                  cols="12"
              >
                <SuggestIndexGroups
                    v-model="IndexForm.IndexGroup"
                    :error-messages="errors.IndexGroup"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Skupina filtrov"
                    :createButton="true"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <v-text-field
                    v-model="IndexForm.title"
                    :error-messages="errors.title"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Názov"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <v-btn
                    type="submit"
                    :rounded="true"
                    :outlined="true"
                    :loading="loading"
                    :disabled="loading"
                    color="success"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>

                  Vytvoriť
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  import Indexes from '@/services/indexes'

  import SuggestIndexGroups from '@/components/IndexGroups/Suggest'

  export default {
    name: 'Create',
    props: [
      'IndexGroup'
    ],
    components: {
      SuggestIndexGroups
    },
    data() {
      return {
        loading: false,
        dialog: false,
        IndexForm: {},
        errors: {}
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      closeDialog() {
        this.dialog = false
      },
      loadData() {
        this.dialog = true

        this.IndexForm = {
          IndexGroup: (
            this.IndexGroup
              ? this.IndexGroup.id
              : null
          ),
          title: ''
        }

        this.errors = {}
      },
      async submit() {
        this.loading = true

        await Indexes
          .create({
            data: this.IndexForm
          })
          .then((response) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: response.data.message
            })

            this.closeDialog()

            this.$emit('refresh')

            this.$emit('init')
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.closeDialog()

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
